/*@flow*/
import React from 'react';
import cx from 'classnames';
import type { Breakpoints } from '../types';

type PropsT = {
  label?: React$Node,
  breakpoints?: Breakpoints,
  htmlFor?: string,
  id?: string,
  className?: any,
  isRequired?: boolean,
};

export default (props: PropsT): React$Node => {
  const { label, breakpoints, htmlFor, id, isRequired } = props;
  if (!label) return null;
  const classConfig = breakpoints ? breakpoints.getLabelClassName() : {};
  classConfig['col-form-label'] = true;
  classConfig.required = Boolean(isRequired);

  return (
    <label
      htmlFor={htmlFor}
      id={id}
      className={cx(classConfig, props.className)}
    >
      {label}
    </label>
  );
};
